import queryString from 'querystring';
import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('CATEGORIES_ROOT_CHIDRENS').plugin(axiosPlugin, {template: "array"});
let fetchAction = redux.fetchActionGet();


export const TYPES = redux.types;

export const fetchCategoriesRoot = (categoryId,query = {}) => fetchAction(`/categories/find-menu/${categoryId}?${queryString.stringify(query)}`);
export const fetchCategoriesRootNotIa = () => fetchAction(`/categories/?slug!=genre,temperature,media,voissa&sort=title`);
export const fetchCategoriesRootMedia = (query) => fetchAction(`/categories/childrens-root?slug!=media,voissa&sort=title`);

export const resetCategoriesRoot = () => redux.actions.reset();

export const categoriesRoot = redux.reducer();
